import { useMemo, useEffect, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import { useTranslation } from 'react-i18next';
import { Divider } from "@mui/material";

function HCViewArudhaPadas({ tableData }) {
    const { t } = useTranslation();
    const dataTableData = {
        columns: [
          { Header: t("Name"), accessor: "key" },
          { Header: t("VALUE"), accessor: "value" },
        ],
        rows:tableData
    }
    return (
            <MDBox pt={0} pb={1} id="bases-ref">
                <MDBox mb={1}>
                    <Card>
                        {/* <MDBox p={3} lineHeight={1} mb={0} display="flex" alignItems="center">
                            <MDTypography variant="h5" fontWeight="medium">
                            { "ආරූඩ පාද" }
                            </MDTypography>
                            <Divider  variant="fullWidth" sx={{ flexGrow: 1, marginLeft: 2 }} />
                        </MDBox> */}
                        <DataTable 
                        canSearch={false} 
                        entriesPerPage={false}
                        showTotalEntries={false}
                        table={dataTableData} />
                    </Card>
                </MDBox>
            </MDBox>
    );
};

HCViewArudhaPadas.propTypes = {
    tableData: PropTypes.array,
  };

export default HCViewArudhaPadas;